<template>
  <h1 class="sr-only">Frequently Asked Questions | VORTEC</h1>
  <FAQ />
  <ClientOnly>
    <ContactForm />
  </ClientOnly>
</template>

<script lang="ts" setup>
// Note: the FAQ component emits its own FAQPage (Question/Answer) JSON-LD,
// which is what's eligible for FAQ rich results — so we don't repeat it here.
useSeo({
  title: 'FAQ | VORTEC',
  description:
    'Answers to common questions about working with VORTEC — pricing, timelines, our process, support, NDAs and more.',
  path: '/faq',
});
</script>
